import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AppService } from '../services/app-service';
import { AuthUtility } from '../utility/auth-utility';

export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const appService = inject(AppService);

  // Soporte universal para atajos que usan ?token=
  const tokenParam = route.queryParams['token'];
  if (tokenParam) {
    return router.createUrlTree(['/token', tokenParam]);
  }

  if (AuthUtility.isAuthenticated()) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }

};
